import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import SelectModalListItem from './SelectModalListItem'
import * as properties from '../constants/Properties'
import { setSelectModal } from '../actions/generalActions'
import PropTypes from 'prop-types'
import * as resource from '../constants/Resources'
import { getTranslation } from '../actions/dataActions'

class SelectModal extends Component {
  constructor(props) {
    super(props);
    this.handleTouchTap = this.handleTouchTap.bind(this);
    this.cancelTap = this.cancelTap.bind(this);
  }

  cancelTap() {
    this.props.setSelectModal([], false, 'default');
  }

  handleTouchTap(itemId, description) {
    const { selectModal, setSelectModal } = this.props;
    const callback = selectModal.callback;
    const dispatch = selectModal.dispatch;
    const callbackParams = [itemId, description].concat(selectModal.callbackparams);

    setSelectModal([], false, 'default');

    if (callback !== null) {
      if (dispatch !== null) {
        dispatch(callback.apply(this, callbackParams));
      } else {
        callback.apply(this, callbackParams);
      }
    }
  }

  render() {
    const { selectModal } = this.props;

    return (
      <Modal className="selectModal"
        contentLabel=""
        isOpen={selectModal.show}
        style={properties.selectModalStyle}
      >
        <div className="selectModalContent">
          <div className="selectModalHeader">
            {selectModal.message}
          </div>
          <div className="selectModalList">
            {
              selectModal.listvalues.map(val =>
                <SelectModalListItem
                  key={val.ItemId}
                  Description={val.Description}
                  ItemId={val.ItemId}
                  Callback={this.handleTouchTap}
                />
              )
            }
          </div>
          { selectModal.showCancel && <div className="selectModalFooter">
            <button className="btnCancel" onClick={this.cancelTap} >
              {this.props.getTranslation(resource.CANCEL)}
            </button>
          </div> }
        </div>
      </Modal>
    )
  }
}

SelectModal.propTypes = {
  setSelectModal: PropTypes.func.isRequired,
  selectModal: PropTypes.object.isRequired
}
function mapStateToProps(state) {
  return {
    selectModal: state.generalState.modal.selectModal
  }
}

export default connect(mapStateToProps, 
  { setSelectModal,
    getTranslation
   })(SelectModal)



// WEBPACK FOOTER //
// src/components/SelectModal.jsx